export const GET_STARTED_STEP_ID = 'new';
export const BUSINESS_STEP_ID = 'business';
export const COMPANY_QUESTIONS_STEP_ID = 'company-questions';
export const CHECK_ELIGIBILITY_STEP_ID = 'check-eligibility';
export const CHECK_STEP_ID = 'check';
export const APPLICANT_STEP_ID = 'applicant';
export const DOCUMENTS_STEP_ID = 'documents';
